import React from "react";
import "./client2.css";

const companies = [
    "Deloitte",
    "UNDP",
    "UNFPA",
    "UNIDO",
    "DHL",
    "USAID",
    "Urgent Cargo Handling Limited",
    "Pan Africa Insurance Company (Sanlam)",
    "Bank of Africa",
    "Kenya Commercial Bank",
    "Equity Bank",
    "Safaricom",
    "Airtel",
    "Technoserve",
    "Vike Insurance Brokers",
    "Pacis Insurance",
    "SMEO",
    "Real Africa Safaris",
    "Migotiyo Plantation",
    "Ministry of Finance and Planning",
    "Trade and Development Bank",
    "Gulf African Bank",
    "Forward Sacco",
    "UN Sacco",
    "Meera Construction Limited",
    "Enkishon Group Limited",
    "Enkang",
    "Trust Industries Limited",
    "UAP",
    "Gateway International Limited",
    "Biblica",
    "Afrikon",
    "Peninsula and Racecourse Gardens",
    "Nairobi Safari Club",
    "Kilimo Hai",
    "ELCI",
    "APA Insurance",
    "UAP Insurance",
    "Indra Company",
    "Mellech Group",
    "Linksoft Group",
    "VAELL"
];

const awards = [
    {
        title: "Top 40 under 40 women",
        year: "2015",
        description: "Recognized for contribution to African financial markets"
    },
    {
        title: "Pan-African Financial Warrior Award.",
        year: "2015",
        description: "Recognized for contribution to African financial markets"
    },
    {
        title: "Africa’s Enterprise Reformation Award.",
        year: "2018",
        description: "Recognized for contribution to African financial markets"
    },
    {
        title: "East Africa Business Council Award.",
        year: "2018",
        description: "Recognized for contribution to African financial markets"
    }
];

function Clients2() {
    return (
        <section className="clients2-section">
            <div className="clients2-container">

                <h2 className="clients2-title">Trusted by Industry Leaders</h2>
                <p className="clients2-subtext">Partnering with leading organizations across Africa</p>

                <div className="clients2-card">
                    <div className="clients2-grid">
                        {companies.map((company, index) => (
                            <div key={index} className="clients2-item">
                                {company}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="clients2-awards-section">
                    <h2 className="clients2-awards-title">Awards and Recognition</h2>

                    <div className="clients2-awards-grid">
                        {awards.map((award, index) => (
                            <div key={index} className="clients2-award-card">
                                <div className="clients2-award-icon"></div>
                                <div className="clients2-award-content">
                                    <div className="clients2-award-header">
                                        <span className="clients2-award-year">{award.year}</span>
                                    </div>
                                    <h3 className="clients2-award-title">{award.title}</h3>
                                    <p className="clients2-award-desc">{award.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Clients2;
